<template>
  <v-container fluid color="white--text">
    <v-card flat>
      <v-card-text>
        <v-tabs
            v-model="tab"
            background-color="primary"
            color="basil"
            grow
            centered
            dark
            icons-and-text
        >
          <v-tab
              v-for="item in items"
              :key="item"
          >
            {{ item }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item key="Request Parameters"
          >
            <v-card>
              <v-card-title>Till Payments</v-card-title>
              <v-card-text>
                As a merchant, your beneficiaries can pay for products and services to Till number provided by SasaPay. A POST request to an endpoint below enables that.
              </v-card-text>
              <v-divider/>
              <v-card-text>
                EndPoints:<br/>
                <div class="secondary pa-5" style="color: #e7e3fc">
                  <strong>Sandbox</strong>
                  <p class="ma-2">{{"https://sandbox.sasapay.app/api/v1/waas/customers/lipa-till/"}}</p>
                </div>
              </v-card-text>
              <v-divider/>
              <v-card-text>
                Request Parameters <br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> Change <code>MerchantCode</code> to your <code>{{"MERCHANT_CODE"}}</code> <br/>
                <v-icon color="primary">mdi-access-point-check</v-icon>  <code>TransactionReference</code>  <br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> <code>BeneficiaryAccountNumber</code><br/>
                <v-icon color="primary">mdi-access-point-check</v-icon>  <code>SasaPayBillNumber</code> <br/>
                <v-icon color="primary">mdi-access-point-check</v-icon>  <code>Amount</code> <br/>
                <v-icon color="primary">mdi-access-point-check</v-icon>  <code>TransactionFee</code> <br/>
                <v-icon color="primary">mdi-access-point-check</v-icon>  <code>CallBackUrl</code> <br/>
                <v-icon color="primary">mdi-access-point-check</v-icon>  <code>Reason</code> <br/>


              </v-card-text>
              <v-divider/>
              <v-card-text>
                Expected Results:<br/>

                Sasa<span class="red--text">Pay</span> returns the response status with a detailed message.
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item key="Sample Request"
          >
            <v-card
                color="basil"
                flat
            >
              <v-card-text>
                <code-editor
                    :read_only="true"
                    theme="dark"
                    v-model="code"
                    @lang="changeLanguage"
                    :wrap_code="false"
                    :language_selector="true"
                    class="github_dark"
                    :copy_code="true"
                    font_size="14px"
                    width="100%"
                    :languages="[['php','PHP'],['java','Java'],['python', 'Python'],['javascript', 'Node Js']]"
                ></code-editor>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item key="Sample Response"
          >
            <v-card
                color="basil"
                flat
            >
              <v-card-text>
                <code-editor
                    :read_only="true"
                    theme="dark"
                    v-model="response"
                    :wrap_code="false"
                    :language_selector="true"
                    class="github_dark"
                    :copy_code="true"
                    font_size="14px"
                    width="100%"
                    :languages="[['json','JSON']]"
                ></code-editor>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>

import {getAuthResponse, getCodeSnippets} from "../../../../../shared/snippets/JavaScript/auth";

export default {
  name: "TillPayments",
  data: () =>({
    selectedLanguage:"",
    code:"",
    response:"",
    tab: null,
    items: [
      'Request Parameters', 'Sample Request','Sample Response',
    ],
  }),
  mounted() {
    this.importAuthSnippets()//
    this.importAuthResponse()
  },
  methods:{
    importAuthSnippets(){
      this.code=getCodeSnippets()
    },
    importAuthResponse(){
      this.response=getAuthResponse()
    },
    changeLanguage() {
      console.log(this.code)
    }
  }
}
</script>

<style scoped>

</style>